import { computed } from 'vue';
import { useRemoteConfigStore } from '../stores/remoteConfig.store';

export function useVirtualAccountsB2b() {
  const remoteConfigStore = useRemoteConfigStore();
  const config = remoteConfigStore.getFeatureFlag('feature_virtual_accounts_b2b');

  const isEnabled = computed<boolean>(() => config.value.enabled);

  return { isEnabled };
}
